import { brandDataTrack } from '@tt4b/ttam-enums';
import { ref } from '@vue/composition-api';
import { i18n } from './../../../i18n';

export function useBrandTrackTypePropsList() {
  const list = ref([
    {
      value: brandDataTrack.appTrack,
      label: i18n.t('module_adgroup_track_app'),
    },
    {
      value: brandDataTrack.pixelTrack,
      label: i18n.t('module_adgroup_track_pixel'),
    },
  ]);

  return { list };
}
